export default __webpack_public_path__ + "static/media/link_telegram.f9f5f740.svg";